import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createarray">
                1.&nbsp;<span className="material-symbols-outlined">data_array</span>&nbsp;{translate('createarray')}
            </Typography>
            <p><strong>{translate('createarray')}</strong> 配列作成は配列を作成するためのアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>配列値の保存先</td>
                                <td>$array_1</td>
                            </tr>
                            <tr>
                                <td>{translate('array')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>配列の値のリスト</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$array_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('array')}</span>
                            <div>["red", "green", "blue"]</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "red"
                                            ,"green"
                                            ,"blue"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getelementfromarray">
                2.&nbsp;<span className="material-symbols-outlined">question_mark</span>&nbsp;{translate('getelementfromarray')}
            </Typography>
            <p><strong>{translate('getelementfromarray')}</strong> 配列から要素を見つけてその値を取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>配列の値の保存先</td>
                                <td>$element_1</td>
                            </tr>
                            <tr>
                                <td>{translate('arraydata')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>配列</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('arrayindex')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>取得する要素のインデックスです (0 から始まります)</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('arraydata')}</span>
                            <div>array_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('arrayindex')}</span>
                            <div>0</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>red</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="createobject">
                3.&nbsp;<span className="material-symbols-outlined">data_object</span>&nbsp;{translate('createobject')}
            </Typography>
            <p><strong>{translate('createobject')}</strong> オブジェクトを作成するためのアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>オブジェクトの値の保存先</td>
                                <td>$object_1</td>
                            </tr>
                            <tr>
                                <td>{translate('object')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>オブジェクトを作成するためのキーと値のペアのリスト</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>キー<strong>key</strong>がそれぞれ  <i>product</i>、<i>color</i>、値<strong>value</strong>がそれぞれペン <i>pen</i>、青 <i>blue</i>を持つオブジェクトを作成します。  </p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$object_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('object')}</span>
                            <div>{ `{"product": "pen", "color": "blue"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "product": "pen", 
                                            "color": "blue"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getvaluefromobject">
                4.&nbsp;<span className="material-symbols-outlined">question_mark</span>&nbsp;{translate('getvaluefromobject')}
            </Typography>
            <p><strong>{translate('getvaluefromobject')}</strong> オブジェクトから要素を見つけてその値を取得するアクションです。 <strong>key</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>オブジェクト要素の値の保存先</td>
                                <td>$value_1</td>
                            </tr>
                            <tr>
                                <td>{translate('objectdata')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>オブジェクト</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('objectkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>キー<strong>key</strong>の名前</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$value_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('objectdata')}</span>
                            <div>object_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('objectkey')}</span>
                            <div>product</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>pen</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);